import { render, staticRenderFns } from "./PrivacyProtocol.vue?vue&type=template&id=3473e2ef&"
import script from "./PrivacyProtocol.vue?vue&type=script&lang=js&"
export * from "./PrivacyProtocol.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports